import widget from './widget';
import settings from './settings';

export default {
  widget,
  settings,
  name: 'Box stats per user',
  description: 'Displays graphs for box stats per user'
};



// WEBPACK FOOTER //
// ./app/widgets.new/UserBoxStats/index.js